import { useTheme } from '../contexts/ThemeContext';
import { useCurrentUser } from '../contexts/UserContext';
import './SettingsPage.css';

function ToggleSwitch({ checked, onChange, label, id }) {
  return (
    <label className="toggle-row" htmlFor={id}>
      <span className="toggle-label">{label}</span>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        className={`toggle-switch ${checked ? 'on' : 'off'}`}
        onClick={onChange}
        aria-label={label}
      >
        <span className="toggle-thumb" />
      </button>
    </label>
  );
}

export default function SettingsPage() {
  const { theme, toggleTheme } = useTheme();
  const currentUser = useCurrentUser();
  const isLight = theme === 'light';
  const profileName = currentUser?.name || [currentUser?.firstName, currentUser?.lastName].filter(Boolean).join(' ') || '—';
  const profileEmail = currentUser?.email || currentUser?.emailAddress || '—';
  const profileTagline = currentUser?.tagline || (currentUser?.role ? currentUser.role.charAt(0).toUpperCase() + currentUser.role.slice(1) : 'Member');
  const avatarLetter = profileName.trim().charAt(0) || '?';

  return (
    <div className="settings-page">
      <div className="settings-grid">
        {/* Settings Card */}
        <section className="settings-card settings-main" aria-labelledby="settings-panel-heading">
          <h3 id="settings-panel-heading" className="settings-card-title">Settings</h3>
          <p className="settings-subhead">Appearance</p>

          <div className="theme-preview-row">
            <button
              type="button"
              className={`theme-preview-card ${!isLight ? 'theme-preview-active' : ''}`}
              onClick={() => isLight && toggleTheme()}
              aria-pressed={!isLight}
            >
              <div className="theme-preview-swatch dark-swatch">
                <span className="swatch-bar" />
                <span className="swatch-bar short" />
                <span className="swatch-card" />
              </div>
              <span className="theme-preview-label">Dark</span>
            </button>

            <button
              type="button"
              className={`theme-preview-card ${isLight ? 'theme-preview-active' : ''}`}
              onClick={() => !isLight && toggleTheme()}
              aria-pressed={isLight}
            >
              <div className="theme-preview-swatch light-swatch">
                <span className="swatch-bar" />
                <span className="swatch-bar short" />
                <span className="swatch-card" />
              </div>
              <span className="theme-preview-label">Light</span>
            </button>
          </div>

          <p className="settings-subhead">Notifications</p>
          <div className="settings-toggles">
            <ToggleSwitch id="notif-classes" label="Upcoming class reminders" checked={true} onChange={() => {}} />
            <ToggleSwitch id="notif-streak" label="Daily streak nudges" checked={true} onChange={() => {}} />
            <ToggleSwitch id="notif-announce" label="Platform announcements" checked={false} onChange={() => {}} />
          </div>
        </section>

        {/* Profile Card */}
        <section className="settings-card settings-profile" aria-labelledby="profile-heading">
          <h3 id="profile-heading" className="settings-card-title">Profile</h3>
          <div className="profile-row">
            <div className="avatar-circle">
              {avatarLetter}
            </div>
            <div className="profile-info">
              <p className="profile-name">{profileName}</p>
              <p className="muted-text">{profileTagline}</p>
              <p className="muted-text profile-email">{profileEmail}</p>
            </div>
          </div>
          <div className="settings-field-grid">
            <div className="settings-field">
              <label className="settings-field-label">Display name</label>
              <input
                type="text"
                className="settings-input"
                value={profileName}
                readOnly
              />
            </div>
            <div className="settings-field">
              <label className="settings-field-label">Email address</label>
              <input
                type="email"
                className="settings-input"
                value={profileEmail}
                readOnly
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
